var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('page-title',{attrs:{"showBackButton":false,"title":"Default Home Page"}}),_c('v-alert',{attrs:{"type":"info"}},[_vm._v(" Please change home page in Developer > UI > Appliaction settings. ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }